import { IneligibilityReason } from "@9amhealth/openapi";
import FactorySignupCustomCampaign from "../FactorySignupCustomCampaign";
import HtmlParser from "src/lib/HtmlParser";
import translate from "src/lib/translate";

const StateOfGeorgiaIneligibilityContent = (
  props: FactorySignupCustomCampaign
) => {
  const factoryAlreadyShowsBirthDateReason =
    props.lastIneligibilityReasons.some(
      (reason) => reason.source === IneligibilityReason.source.BIRTH_DATE
    );

  if (factoryAlreadyShowsBirthDateReason) {
    return null;
  }

  const number = props.getContactNumber();

  const withReason = translate("ineligibility.reasonText", {
    context: "BIRTH-DATE-state-of-georgia",
    phoneNumber: number.displayNumber,
    telLink: number.telLink
  });

  return (
    <div>
      <nine-spacer s="md"></nine-spacer>
      {new HtmlParser(withReason).toJsx()}
    </div>
  );
};

export default StateOfGeorgiaIneligibilityContent;
